import type { ArticleFooterFragment } from '../__generated__/ArticleFooter.generated';

import styles from './ArticleSectionRelatedLinkList.module.scss';
import { ArticleSectionRelatedTeaser } from './ArticleSectionRelatedTeaser';
import { ArticleSectionRelatedTeasersClamp } from './ArticleSectionRelatedTeasersClamp';

interface Props {
	links: ArticleFooterFragment['links'];
	className?: string;
}

export function ArticleSectionRelatedLinksContainer({ links = [], className = '' }: Props) {
	if (!links || !Array.isArray(links)) {
		return null;
	}

	const renderedLinks = links.filter(isLinkDefined).map((link) => {
		return <ArticleSectionRelatedTeaser key={link?.url?.toString()} teaser={link} className={styles.relatedArticle} />;
	});

	if (renderedLinks.length === 0) {
		return null;
	}

	return (
		<section className={className}>
			<h2 className={styles.title}>Das könnte Sie auch interessieren</h2>
			<ArticleSectionRelatedTeasersClamp threshold={5}>{renderedLinks}</ArticleSectionRelatedTeasersClamp>
		</section>
	);
}

function isLinkDefined(
	link: NonNullable<ArticleFooterFragment['links']>[number]
): link is NonNullable<NonNullable<ArticleFooterFragment['links']>[number]> {
	if (link == null) {
		return false;
	}

	const { url, label, meta } = link;
	const title = meta?.title;
	return !!(url && (title || label));
}
